import React from "react";
import logo from "../logo.png";
const Navbar = ({ logout }) => {
  return (
    <div className="nav-container">
      <div className="nav-left">
        <img src={logo} alt="cashlens log0" className="navbar-logo" />
        <h1 className="logo-text">cashlens</h1>
      </div>
      <div className="nav-right">
        <button className="navbar-btn" onClick={logout}>
          logout
        </button>
      </div>
    </div>
  );
};

export default Navbar;
